var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShanchuMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 13.5V3.3h2.1V1.8h5v1.5h2.1v10.2a.5.5 0 01-.5.5H3.9a.5.5 0 01-.5-.5z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 2.8a.5.5 0 000 1v-1zm11.6 1a.5.5 0 100-1v1zm-8.3-2v-.5a.5.5 0 00-.5.5h.5zm5 0h.5a.5.5 0 00-.5-.5v.5zm-8.3 2h1.2v-1H2.2v1zm.7-.5v10.2h1V3.3h-1zm1 11.2h8.2v-1H3.9v1zm8.7-10.7h1.2v-1h-1.2v1zm.5 9.7V3.3h-1v10.2h1zM3.4 3.8h2.1v-1H3.4v1zm2.1 0h2.45v-1H5.5v1zm.5-.5V1.8H5v1.5h1zm-.5-1h5v-1h-5v1zm2.45 1.5h2.55v-1H7.95v1zm2.55 0h2.1v-1h-2.1v1zm-.5-2v1.5h1V1.8h-1zm2.1 12.7a1 1 0 001-1h-1v1zm-9.2-1a1 1 0 001 1v-1h-1z",
    fill: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 6.5a.5.5 0 00-1 0h1zm-1 4.5a.5.5 0 001 0h-1zm3.6-4.5a.5.5 0 00-1 0h1zm-1 4.5a.5.5 0 001 0h-1zM6.2 6.5V11h1V6.5h-1zm2.6 0V11h1V6.5h-1z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shanchu_mian.d49d2023.svg";
export { SvgTongyongShanchuMian as ReactComponent };